import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const normalizeResponse = (value) => {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
    return JSON.parse(trimmed);
  }
  return trimmed;
};

const ajaxDossieEvent = ({ ll, dataPost, rejectMessage }) => {
  const users = getSession();
  const emp = users[0];
  const uid = users[3];
  const token = users[14];

  return new Promise(function (resolve, reject) {
    try {
      const dd = [
        base64_encode(emp),
        base64_encode(uid),
        base64_encode(JSON.stringify(dataPost || {})),
      ];

      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type: 'POST',
        dataType: 'text',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          pp: base64_encode('dossieAutomatico'),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
          tk: token,
        },
        success: function (data) {
          try {
            const responseData = normalizeResponse(data);

            if (responseData === 'erro_auth' || responseData === 'sessao_expirada') {
              sessionStorage.clear();
              window.location.href = '/auth/login';
              return;
            }

            const decoded = JSON.parse(base64_decode(responseData));
            resolve([200, decoded]);
          } catch (decodeError) {
            console.error('dossieAutomatico:response decode error', { ll, data, decodeError });
            reject([400, { message: 'Resposta inválida do servidor' }]);
          }
        },
        error: function (xhr, status, error) {
          console.error('Erro AJAX dossieAutomatico:', { ll, xhr, status, error });
          reject([400, { message: rejectMessage }]);
        },
      });
    } catch (err) {
      reject([500, { message: 'Server Error' }]);
    }
  });
};

const RestDossieAutomaticoPost = (config) => {
  const { dest, dataPost } = JSON.parse(config.data);
  const acao = dest.trim();

  const mensagensErro = {
    catalogRelatorios: 'Erro ao carregar catálogo de relatórios',
    salvarDossie: 'Erro ao salvar dossiê',
    listarDossies: 'Erro ao listar dossiês',
    cfopList: 'Erro ao carregar lista de CFOPs',
    listarHistorico: 'Erro ao carregar histórico de execuções',
    solicitarExecucaoManual: 'Erro ao solicitar execução manual',
    presignArquivo: 'Erro ao gerar link de download',
    deletarDossie: 'Erro ao excluir dossiê',
    enviarEmailHistorico: 'Erro ao enviar e-mail',
  };

  if (!(acao in mensagensErro)) {
    return new Promise((_, reject) => reject([400, { message: `Destino desconhecido: ${acao}` }]));
  }

  return ajaxDossieEvent({ ll: acao, dataPost, rejectMessage: mensagensErro[acao] });
};

const RestDossieAutomaticoGet = (config) => {
  const acao = config?.params?.dest || '';

  if (acao !== 'listarDossies') {
    return new Promise((_, reject) => reject([400, { message: `Destino desconhecido: ${acao}` }]));
  }

  return ajaxDossieEvent({ ll: 'listarDossies', dataPost: {}, rejectMessage: 'Erro ao listar dossiês' });
};

export { RestDossieAutomaticoPost, RestDossieAutomaticoGet };
